/** CollisionShape2D registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseCollisionShape2D } from './parser';
const collisionShape2DRegistration = {
    typeName: 'CollisionShape2D',
    parser: parseCollisionShape2D,
};
nodeRegistry.register(collisionShape2DRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map